import styled from "@emotion/styled";
import React, { PropsWithChildren } from "react";
import { FullWidth } from "../core/BodyLayout";
import {
  fontSmallHeadline,
  fontXlHeadline,
} from "src/design-system/styles/fonts";
import { breakpointDesktopOnly } from "src/design-system/styles/breakpoints";
import { compassColors } from "src/utils/styling";
import { ClinicalNavBar } from "./ClinicalNavBar";
import Pill from "./images/pill.svg";
import { Text } from "src/components/core/Text";
import { ClinicalIntroContentProps } from "./ClinicalIntroContent/commonStyles";
import { isFreemiumClinicalRoute } from "@utils/userSegment";

const Container = styled(FullWidth)`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  @media ${breakpointDesktopOnly} {
    margin-bottom: 0;
  }
`;

const HeaderSection = styled.div`
  background: ${compassColors.blueberry};
  border-bottom-right-radius: 80px;
  margin-bottom: 32px;
`;

const FindOutIfEligibleText = styled.div`
  ${fontSmallHeadline}
  color: ${compassColors.white};
  text-align: center;
  margin: 32px;
  font-weight: 400;
  @media ${breakpointDesktopOnly} {
    ${fontXlHeadline}
    color: ${compassColors.white};
    font-weight: 400;
  }
`;

const PillImage = styled.img`
  width: 20px;
  display: inline-block;
  position: relative;
  top: 4px;
  @media ${breakpointDesktopOnly} {
    width: 40px;
    top: 6px;
  }
`;

export default function ClinicalHeroSection({
  gotoNextPage,
  gotoWeightLandingPage,
  isLDSAudience,
  children,
}: PropsWithChildren<ClinicalIntroContentProps>) {
  const translationSuffix = isLDSAudience ? "lds" : "default";
  return (
    <Container>
      <HeaderSection>
        <ClinicalNavBar
          gotoNextPage={gotoNextPage}
          gotoWeightLandingPage={gotoWeightLandingPage}
          showLoginLink={!isFreemiumClinicalRoute()}
          showNoomForWorkLinks={!isFreemiumClinicalRoute()}
          noomWeightText={{
            i18nKey: "introClinical:navBar:switchToNoomWeight",
          }}
        />
        <FindOutIfEligibleText>
          <Text
            i18nKeyOrText={`t:introClinical:hero:text:${translationSuffix}`}
            components={{
              PillImage: <PillImage src={Pill} />,
            }}
          />
        </FindOutIfEligibleText>
      </HeaderSection>

      {children}
    </Container>
  );
}
